<script>
  /* Executable code section of the program */
  // Components importation
  import AttendeesModal from "../../components/Modals/ModalAttendees.svelte";
  import ExcelModal from "../../components/Modals/ExcelModal.svelte";
  import AttendeeCard from "../../components/Cards/AttendeeCard.svelte";
  import EmptyTable from "../../components/EmptySections/EmptyTable.svelte";
  import Loader from "../../components/Loader.svelte";
  //Tool importation
  import {
    attendeesData,
    isModalAttendesOn,
    isUploadFilesModalOn,
    isAttendeeCardModalOn,
    temporalAttendeeData,
    isModalUpdate,
    temporalData,
    userLocalData,
    isProtectedRoute,
    attendeesUnavailableMeets,
    isAlertOn,
    temporalEventList,
    alertMessagge,
    isReloadNecessary
  } from "../../apis/storage";
  import {
    getCollection,
    auth,
    filterFuction,
    getPaginatedDocuments,
    updateMultipleDocuments,
    getSpecificDocuments,
    searchDocumentsByKeyword
  } from "../../apis/APIS";
  import { onMount } from "svelte";
  import { navigate } from "svelte-routing";
  import { onAuthStateChanged } from "firebase/auth";
  import AlertModal from "../../components/Modals/alertModal.svelte";

  //Auxiliary variables
  let isLoadedContent = false;
  let counter = 0;

  //Variables necessary for pagination and filters
  let attendeesArray = [];
  let totalAttendeesArray = [];
  let totalFilterArray = [];
  let filterPages = [];
  let eventsNames = [];
  let reservDocument = [];
  $: dinamicAttendeesData = [];
  let lastDocument = null;
  let isArrayComplete = false;
  let isFilterFuction = false;
  let eventUser = "";
  let typedValue = "";
  let category = "";
  let index = 0;
  let totalDocuments = 15;

  // Definition of the window witdh
  const windowWidth = window.innerWidth;

  //Function to display modal
  const displayUpdateModal = (data) => {
    $isModalUpdate = true;
    $temporalData = data;
  };

  //Function to display card modal
  const displayCardModal = (data) => {
    $isAttendeeCardModalOn = true;
    $temporalAttendeeData = data;
  };

  //Function to filter data
  const filterAttendees = async (value) => {
    if (typedValue !== "") {
    isFilterFuction = true;
    let categorySelect = document.querySelector(".categorySelect");
    let categoryValue = categorySelect.value;
    category = categorySelect.value;
    let newFilter = await searchDocumentsByKeyword("users",category,value,eventUser)
    
    
    /* 
    const { completeCollection, lastDoc } = await filterFuction(
      "users",
      totalDocuments,
      eventUser,
      categoryValue,
      value
    ); */
    totalFilterArray.push(newFilter);
    dinamicAttendeesData = newFilter;
    index = 0;/* 
    reservDocument.push(lastDoc);
    lastDocument = lastDoc; */
    }
  };

  //Function to get documents and create pagination
  const nextPageData = async () => {
    if (isFilterFuction) {
      //filter pagination fuction
      if (!isArrayComplete) {
        const { completeCollection, lastDoc } = await filterFuction(
          "users",
          totalDocuments,
          eventUser,
          category,
          typedValue,
          lastDocument
        );

        if (completeCollection === undefined) {
          isArrayComplete = true;
        }

        if (completeCollection !== undefined) {
          if (
            !totalFilterArray.some(
              (obj) =>
                JSON.stringify(obj) === JSON.stringify(completeCollection[0])
            ) &&
            !isArrayComplete
          ) {
            totalFilterArray.push(completeCollection);
            dinamicAttendeesData = completeCollection;
            lastDocument = lastDoc;
            reservDocument.push(lastDoc);
            index++;
          }
        }
      } else {
        if (index < totalFilterArray.length - 1) {
          index++;
        }
        dinamicAttendeesData = totalFilterArray[index];
      }
    }

    //normal pagination function
    else {
      if (!isArrayComplete) {
        const { documents, lastDoc } = await getPaginatedDocuments(
          "users",
          eventUser,
          totalDocuments,
          lastDocument
        );
        if (documents.length === 0) {
          isArrayComplete = true;
        }

        if (documents.length > 0) {
          if (
            !totalAttendeesArray.some(
              (obj) => JSON.stringify(obj) === JSON.stringify(documents[0])
            ) &&
            !isArrayComplete
          ) {
            totalAttendeesArray.push(documents);
            dinamicAttendeesData = documents;
            lastDocument = lastDoc;
            reservDocument.push(lastDoc);
            index++;
          }
        }
      } else {
        if (index < totalAttendeesArray.length - 1) {
          index++;
        }
        dinamicAttendeesData = totalAttendeesArray[index];
      }
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const prevPageData = async () => {
    if (index >= 1) {
      if (isFilterFuction) {
        //filter pagination fuction
        index--;
        if (!isArrayComplete) {
          lastDocument = reservDocument[index];
        }
        dinamicAttendeesData = totalFilterArray[index];
      } else {
        //normal pagination function
        index--;
        if (!isArrayComplete) {
          lastDocument = reservDocument[index];
        }
        dinamicAttendeesData = totalAttendeesArray[index];
      }
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  //Function to get attendees acording to event
  const eventAttendees = async () => {
    let eventSelect = document.querySelector(".eventSelect");
    let eventValue = eventSelect.value;
    lastDocument = null
    eventUser = eventValue;
    attendeesArray = [];
    dinamicAttendeesData = [];
    reservDocument = [];
    totalFilterArray = [];
    totalAttendeesArray = []
    index = 0

    //fetch documents
    const { documents, lastDoc } = await getPaginatedDocuments(
      "users",
      eventValue,
      totalDocuments,
      lastDocument
    );
    
    totalAttendeesArray.push(documents);
    attendeesArray = documents;
    dinamicAttendeesData = attendeesArray;
    lastDocument = lastDoc;
    reservDocument.push(lastDoc);
  };

  //Reset function
  const resetDocuments = async () => {
    location.reload();
  };

  //Function to select all attendees
  const selectAll = async () => {
    let categorySelect = document.querySelector(".categorySelect");
    let categoryValue = categorySelect.value;
    category = categorySelect.value;
    const { completeCollection, lastDoc } = await filterFuction(
      "users",
      300,
      eventUser,
      categoryValue,
      typedValue
    );
    completeCollection.forEach((element) => {
      $attendeesUnavailableMeets.push({
        id: element.id,
        fieldName: "availableMeet",
        values: !element.availableMeet,
      });
    });
  };
  //Function to display alert modal
  const displayAlert = () =>{
    $isAlertOn = true
  }

  //functions to get events for the checkbox
  // Function to handle checkbox events
  const handleCheck = (e,attendee) => {
    let itemExist
    try {
      itemExist = $attendeesUnavailableMeets.some(item => item.id === attendee.id);
      if (itemExist) {
        deleteInvitedAttendee(attendee)
      } else {
        inviteAttendee(attendee,!attendee.availableMeet)
      }
      
    } catch (error) {
      console.error("Error handling checkbox event:", error);
    }
  };

  //Functions to add attendees
  // Add attendee
  const inviteAttendee = (data, check) => {
    $attendeesUnavailableMeets.push({
      id: data.id,
      fieldName: "availableMeet",
      values: check,
    });
  };

  // Delete attendee
  const deleteInvitedAttendee = (data) => {
    // Correctly filter attendees that DO NOT match the ID
    $attendeesUnavailableMeets = $attendeesUnavailableMeets.filter(
      (attendee) => attendee.id !== data.id
    );
  };

  //Function to save changes to the database
  const saveChanges = () => {
    if ($attendeesUnavailableMeets.length > 0) {
      
    updateMultipleDocuments("users", $attendeesUnavailableMeets).then(
      () => {
        $alertMessagge = "All data was successfully updated."
        $isReloadNecessary = true
        displayAlert()
      }
    );
    } else {
      $alertMessagge = "No modifications have been applied to the data."
      displayAlert()
    }
    /*totalFilterArray */
  };
  //Function to go back
  const goBack= () => {
    window.history.back();
  }

  //Logged-in session verification
  //Initial function execution
  onMount(async () => {
    onAuthStateChanged(auth, async (user) => {
      if (user) {
        $isProtectedRoute = true;
        $userLocalData = await getSpecificDocuments("users","email",user.email)
        if ($userLocalData[0].userRole === "attendee") {
          navigate("/home");
        }

        eventsNames = await getCollection("events");
        $temporalEventList = eventsNames.map(element =>{
          return element.tittle
        })
        $attendeesData = [];
        dinamicAttendeesData = [];
        //Set timer
        setTimeout(() => (isLoadedContent = true), 1500);
      } else {
        navigate("/");
      }
    });
  });
  /* End of the section */
</script>

<!-- Section to place the HTML code -->
{#if isLoadedContent}
  <body>
    <div class="backBtnContainer">
      <button class="backBtn" on:click="{goBack}"> <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-left" viewBox="0 0 16 16">
        <path fill-rule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"/>
      </svg> Go Back</button>
    </div>
    <div class="headerContent">
      <h3>Attendees List</h3>
      <div class="btnContainer">
        <a href="https://docs.google.com/spreadsheets/d/18Q7tiEEocaPF3r4aIcty0n2xE23NLPsA/edit?usp=drive_link&ouid=103772134280271960431&rtpof=true&sd=true"
         download="Attendees Excel Template.xlsx"><button
          class="actionButton"
          >Excel Template</button
        ></a>
        <button
          class="actionButton"
          on:click={() => ($isUploadFilesModalOn = true)}
          >Add Attendees Excel</button
        >
        <button
          class="actionButton"
          on:click={() => ($isModalAttendesOn = true)}>Add Attendees</button
        >
      </div>
    </div>
    <div class="filterBottonsContainer">
      <div class="inputContainer">
        <div class="form-floating">
          <select
            class="form-select eventSelect"
            name="country"
            id="floatingSelect"
            aria-label="Floating label select example"
            on:change={eventAttendees}
          >
            <option selected>Select a event</option>
            {#each eventsNames as event}
              <option value={event.tittle}>{event.tittle}</option>
            {/each}
          </select>
          <label for="floatingSelect">Event</label>
        </div>
        <div class="form-floating">
          <select
            class="form-select categorySelect"
            name="company"
            id="floatingSelect"
            aria-label="Floating label select example"
          >
            <option selected value="">Select a category</option>
            <option value="name">Name</option>
            <option value="surname">Surname</option>
            <option value="country">Country</option>
            <option value="company">Company</option>
            <option value="jobtittle">Jobtittle</option>
          </select>
          <label for="floatingSelect">Categories</label>
        </div>
        <div class="form-floating">
          <input
            type="email"
            class="form-control"
            id="floatingInput"
            placeholder="name@example.com"
            bind:value={typedValue}
          />
          <label for="floatingInput">Search</label>
        </div>
      </div>
      <div class="buttonsContainer">
        <button
          class="actionButton filterBtn"
          on:click={() => filterAttendees(typedValue)}>Search</button
        >
        <button class="actionButton filterBtn" on:click={() => resetDocuments()}
          >Reset</button
        >
        {#if isFilterFuction}
          <button class="actionButton filterBtn" on:click={selectAll}
            >Select All</button
          >
        {/if}
        <button class="actionButton filterBtn" on:click={saveChanges}
          >Save Changes</button
        >
      </div>
    </div>
    <div class="listContainer">
      {#if dinamicAttendeesData.length > 0}
        <table class="table table-striped">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Name</th>
              {#if windowWidth > 1100}
                <th scope="col">Surname</th>
                <th scope="col">Country</th>
                <th scope="col">Company</th>
                <th scope="col">Jobtittle</th>
                <th scope="col">Email</th>
              {:else if windowWidth > 700 && windowWidth <= 1100}
                <th scope="col">Country</th>
                <th scope="col">Company</th>
              {/if}
              <th scope="col">Available Meets</th>
              <th scope="col">Description</th>
              <th scope="col">Edit</th>
            </tr>
          </thead>
          <tbody>
            {#each dinamicAttendeesData as attendee, index}
              {#key attendee}
                <tr>
                  <th scope="row">{index + 1}</th>
                  {#if windowWidth < 700}
                    <td>{attendee.name} {attendee.surname}</td>
                  {/if}
                  {#if windowWidth > 1100}
                    <td>{attendee.name || "N/A"}</td>
                    <td>{attendee.surname || "N/A"}</td>
                    <td>{attendee.country || "N/A"}</td>
                    <td>{attendee.company || "N/A"}</td>
                    <td>{attendee.jobtittle || "N/A"}</td>
                    <td>{attendee.email || "N/A"}</td>
                  {:else if windowWidth > 700 && windowWidth <= 1100}
                    <td>{attendee.name || "N/A"} {attendee.surname || "N/A"}</td
                    >
                    <td>{attendee.country || "N/A"}</td>
                    <td>{attendee.company || "N/A"}</td>
                  {/if}
                  <td>
                    <div class="form-check form-switch">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="flexSwitchCheckChecked"
                        bind:checked={attendee.availableMeet}
                        on:click={(e) => handleCheck(e, attendee)}
                      />
                    </div>
                  </td>
                  <td style="text-align: center;">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      class="bi bi-eye-fill icon"
                      viewBox="0 0 16 16"
                      on:click={() => displayCardModal(attendee)}
                      on:keypress={() => displayCardModal(attendee)}
                    >
                      <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0" />
                      <path
                        d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
                      />
                    </svg>
                  </td><td style="text-align: center;">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      class="bi bi-pencil-square icon"
                      viewBox="0 0 16 16"
                      on:click={() => displayUpdateModal(attendee)}
                      on:keypress={() => displayUpdateModal(attendee)}
                    >
                      <path
                        d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"
                      />
                      <path
                        fill-rule="evenodd"
                        d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
                      />
                    </svg>
                  </td>
                </tr>
              {/key}
            {/each}
          </tbody>
        </table>
      {:else}
        <EmptyTable />
      {/if}
    </div>

    <div class="paginationBtns">
      <button class="actionButton pageBtn" on:click={prevPageData}
        >Previous page</button
      >
      <button class="actionButton pageBtn" on:click={nextPageData}
        >Next page</button
      >
    </div>
  </body>
  {#if $isModalAttendesOn || $isModalUpdate}
    <AttendeesModal />
  {/if}
  {#if $isUploadFilesModalOn}
    <ExcelModal />
  {/if}
  {#if $isAttendeeCardModalOn}
    <AttendeeCard user={"attendee"} />
  {/if}
{:else}
  <Loader />
{/if}
{#if $isAlertOn}
<AlertModal />
{/if}

<!-- End of the section -->
<style>
  /* Section to place the code styles */
  /* Principal styles */
  body {
    background-color: #f4f4f4;
    width: 100%;
    min-height: 89vh;
    height: auto;
    padding: 50px 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  /* Back Button styles */
    .backBtnContainer{
    width: 90%;
    display: flex;
    justify-content: flex-start;
  }
  .backBtn{
    background-color: #f4f4f4;
    border: none;
  }
  .backBtn:hover{
    color: #ed2824;
    border-bottom: 1px solid #ed2824;
  }
  .actionButton {
    width: 200px;
    border-radius: 12px;
    font-size: 14px;
    font-weight: 500;
    padding: 8px 16px;
    background-color: white;
    color: #111;
    border: 1px solid #444;
    transition: all 0.3s ease-in-out;
    margin: 0 10px;
  }

  .actionButton:hover {
    cursor: pointer;
    box-shadow: #000 0px 0px 5px;
    transform: scale(1.01);
    border-color: #fff;
    background-color: #ed2824;
    color: White;
  }
  /* Header content styles */
  .headerContent {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 80%;
    padding: 20px;
  }
  /* Filter section styles */
  .filterBottonsContainer {
    width: 80%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 10px 0;
  }
  /* Input content styles */
  .inputContainer {
    display: flex;
    margin: 5px 0;
  }
  .form-floating {
    margin: 0 10px;
  }
  .filterBtn,.pageBtn {
    height: 40px;
    width: 200px;
  }
  /* Buttons content styles */
  .buttonsContainer {
    margin: 5px 0;
  }

  .listContainer {
    background-color: white;
    width: 80%;
    height: auto;
    padding: 30px;
  }
  .icon:hover {
    cursor: pointer;
    color: #ed2824;
  }

  .paginationBtns {
    width: 90%;
    height: auto;
    padding: 20px;
    display: flex;
    justify-content: center;
  }
  /* /////////Tablets///////// */
  @media (min-width: 700px) and (max-width: 1100px) {
    .headerContent {
      width: 90%;
    }
    .filterBottonsContainer {
      width: 90%;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
    }
  .filterBtn {
    height: 40px;
    width: 150px;
  }
    .listContainer {
      background-color: white;
      width: 90%;
      height: auto;
      padding: 30px;
    }
  }
  /* /////////Cellphones ///////// */
  @media (max-width: 700px) {
    .headerContent {
      width: 100%;
      padding: 10px;
      flex-direction: column;
      font-size: 25px;
      align-items: flex-start;
    }
    .filterBottonsContainer {
      width: 100%;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      padding: 10px;
    }
     /* Buttons content styles */
  .buttonsContainer {
    margin: 5px 0;
    width: 100%;
  }
    .inputContainer{
      flex-direction: column;
      width: 100%;
    }
    .form-floating {
      margin: 5px 0;
      width: 300px;
    }
    .filterBtn {
      font-size: 15px;
      padding: 10px;
      height: auto;
      width: 100%;
      margin: 10px 0;
    }
    .actionButton{
      font-size: 15px;
      width: 100%;
      padding: 10px;
      margin: 5px 0;
    }
    .listContainer {
      background-color: white;
      width: 100%;
      height: auto;
      padding: 10px;
    }
    .paginationBtns{
      width: 100%;
    }
    .pageBtn{
      margin: 0 5px;
      width: 200px;
    }
  }

  /* End of the section */
</style>
